<template>
  <md-card
    elevation="15"
    v-if="affiliation"
    v-bind:class="hidediv ? 'dis' : ''"
    :id="affiliation.AffiliationIdentifier.Id"
    class="gutter"
  >
    <div @click="isMobile ? selectAffiliationCardAndVote() : ''">
      <md-card-header class="md-layout">
        <div class="md-layout-item md-size-15">
          <span v-if="affiliation.Logo">
            <img
              class="imgsize"
              v-bind:src="
                'data:image/jpeg;base64,' + affiliation.Logo[0].Binary.value
              "
              aria-hidden="true"
              role="presentation"
              :alt="$t('affiliation.logo')"
            />
          </span>
          <span v-else>
            <img
              class="imgsize"
              src="outline_image_not_supported.png"
              aria-hidden="true"
              role="presentation"
              alt=""
            />
          </span>
        </div>
        <div class="md-layout-item md-size-55 block-lista">
          <span class="election-title bold">
            {{ affiliation.AffiliationIdentifier.RegisteredName }} </span
          ><br />
          <span class="md-caption dark-grey" v-if="affiliation.Description">
            {{ affiliation.Description }}
          </span>

          <br />
        </div>

        <div class="md-layout-item md-size-10 md-xsmall-hide">
          <md-button
            v-if="!isMobile && affiliation.Profile"
            class="md-icon-button md-dark"
            @click.stop="info = true"
            :id="'info-' + affiliation.AffiliationIdentifier.Id"
            v-bind:style="isMobile ? 'display: none' : ''"
            :aria-label="
              $t('affiliation.info-list-button') +
                affiliation.AffiliationIdentifier.RegisteredName
            "
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              >{{ $t("affiliation.info-list-button") }}</md-tooltip
            >
            <md-icon class="md-size-1x" aria-hidden="true" role="presentation"
              >info_outline</md-icon
            >
          </md-button>
        </div>
        <div class="md-layout-item md-size-10 md-xsmall-size-15">
          <md-button
            class="md-icon-button md-primary"
            @click.stop="
              vote(false);
              affiliationSelect();
            "
            :disabled="disabled && !voted"
            :aria-disabled="disabled && !voted"
            ref="voteButton"
            :id="'vote-' + affiliation.AffiliationIdentifier.Id"
          >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              >{{ $t("affiliation.select-list-button") }}</md-tooltip
            >
            <md-icon
              class="md-size-2x"
              v-if="voted"
              aria-hidden="true"
              role="presentation"
              >check_circle</md-icon
            ><span v-if="voted" class="screenreader"
              >{{ $t("affiliation.selected-list-button") }}
              {{ affiliation.AffiliationIdentifier.RegisteredName }}</span
            >
            <md-icon
              class="md-size-1x"
              v-if="!voted && !disabled"
              aria-hidden="true"
              role="presentation"
              >check_circle_outline</md-icon
            ><span v-if="!voted && !disabled" class="screenreader"
              >{{ $t("affiliation.select-list-button") }}
              {{ affiliation.AffiliationIdentifier.RegisteredName }}</span
            >
            <md-icon
              class="md-size-1x"
              v-if="disabled && !voted"
              aria-hidden="true"
              aria-disabled="true"
              role="presentation"
              >block</md-icon
            ><span v-if="disabled && !voted" class="screenreader">{{
              $t("affiliation.select-list-button")
            }}</span>
          </md-button>
        </div>
        <div class="md-layout-item md-size-10 md-xsmall-size-15">
          <md-button
            v-if="this.affiliation.AffiliationContest && hasContest"
            @click.stop="preferenceSelect()"
            :class="
              voted
                ? 'md-icon-button md-plain md-primary'
                : 'md-icon-button  md-primary'
            "
            :disabled="!voted"
            :aria-disabled="!voted"
            ref="openPreferences"
            :id="'pref-' + affiliation.AffiliationIdentifier.Id"
            :aria-label="
              $t('affiliation.preferences-choices-button') +
                affiliation.AffiliationIdentifier.RegisteredName
            "
          >
            <md-icon
              v-bind:class="voted ? 'md-size-2x' : 'md-size-1x'"
              aria-hidden="true"
              role="presentation"
              :aria-disabled="!voted"
              >person</md-icon
            >
            <md-tooltip
              v-bind:style="isMobile ? 'display: none;' : ''"
              class="tooltip"
              >{{ $t("affiliation.preferences-choices-button") }}</md-tooltip
            >
          </md-button>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-size-30" style="text-align: left">
            <md-button
              v-if="isMobile && affiliation.Profile"
              class="md-icon-button md-dark"
              v-bind:style="isMobile ? '' : 'display: none'"
              @click.stop="info = true"
              :id="'info-' + affiliation.AffiliationIdentifier.Id"
              :aria-label="$t('affiliation.info-list-button')"
            >
              <md-tooltip
                v-bind:style="isMobile ? 'display: none;' : ''"
                class="tooltip"
                >{{ $t("affiliation.info-list-button") }}</md-tooltip
              >
              <md-icon class="md-size-1x" aria-hidden="true" role="presentation"
                >info_outline</md-icon
              >
            </md-button>
          </div>
          <div class="md-layout-item md-size-60 preferenze">
            <div
              class="md-caption preferences-color"
              v-bind:class="{ nero: votedPreferences.length > 0 }"
              v-if="affiliation.AffiliationContest && hasContest"
            >
              <span aria-hidden="true" role="presentation" class="max-votes">
                {{ $t("affiliation.preferences-selectable") }}:
                {{ affiliation.AffiliationContest.MaxVotes }}
              </span>
              <span>
                <span aria-hidden="true" role="presentation"
                  >{{ $t("affiliation.preferences-selected") }}:
                </span>
                <span
                  v-if="votedPreferences.length == 0 && !voted"
                  aria-hidden="true"
                  role="presentation"
                >
                  --
                </span>
                <span
                  v-if="votedPreferences.length == 0 && voted"
                  class="primary-color"
                >
                  <span class="screenreader"
                    >{{ $t("affiliation.preferences-selected") }}:
                  </span>
                  {{ $t("affiliation.no-preferences-selected") }}
                </span>
                <span v-if="votedPreferences.length > 0" class="primary-color">
                  <span class="screenreader"
                    >{{ $t("affiliation.preferences-selected") }}:
                  </span>
                  {{ votedPreferences.length }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </md-card-header>
    </div>
    <md-dialog
      role="dialog"
      :aria-modal="info"
      id="info-affiliation"
      :md-fullscreen="false"
      :md-active.sync="info"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      @keydown.tab="
        utils.handleTabNavigation($event, null, null, '#info-affiliation', null)
      "
      @md-opened="
        hidediv = true;
        $root.$emit('lock');
        noScroll();
        !isMobile ? utils.modalOpened('#info-affiliation') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        hidediv = false;
        $root.$emit('unlock');
        scroll();
      "
    >
      <md-dialog-content>
        <div class="md-title" style="color: black">
          {{ affiliation.AffiliationIdentifier.RegisteredName }}
        </div>
        <span class="md-subtitle dark-grey">
          <!--<span :style="{ color: 'rgba(0,0,0,0.8)' }">-->
          {{ affiliation.Description }}</span
        >

        <profileInfo :profileInfo="affiliation.Profile"></profileInfo>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button @click="info = false" class="close-button">
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{ $t("affiliation.info-dialog.close-button") }}</md-tooltip
          >
          {{ $t("affiliation.info-dialog.close-button") }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>
    <md-dialog
      role="dialog"
      v-if="hasContest"
      :aria-modal="preferenceDialog"
      id="gotopreference-dialog"
      :md-fullscreen="false"
      @keydown.tab="
        utils.handleTabNavigation(
          $event,
          null,
          null,
          '#gotopreference-dialog',
          null
        )
      "
      @md-opened="
        hidediv = true;
        $root.$emit('lock');
        noScroll();
        !isMobile ? utils.modalOpened('#gotopreference-dialog') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        hidediv = false;
        scroll();
        $root.$emit('unlock');
      "
      :md-active.sync="preferenceDialog"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
    >
      <md-dialog-content>
        <div class="md-layout" id="goToPref">
          <div class="md-layout-item md-size-100 preff">
            {{ $t("affiliation.go-to-preference-dialog.text-content")
            }}<md-icon
              class="md-size-1x pref"
              style="color: var(--pcolor) !important"
              aria-hidden="true"
              role="presentation"
              >person</md-icon
            ><span aria-hidden="true" role="presentation"><br /></span
            ><span class="screenreader">{{
              $t("affiliation.preferences-choices-button")
            }}</span>
            {{
              $t("affiliation.go-to-preference-dialog.text-content-continue")
            }}
          </div>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="preferenceDialog = false" class="close-button">
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{
              $t("affiliation.go-to-preference-dialog.close-button")
            }}</md-tooltip
          >
          {{ $t("affiliation.go-to-preference-dialog.close-button") }}
        </md-button>
        <md-button
          id="okGoToPref"
          @click="
            preferenceSelect();
            preferenceDialog = false;
          "
          class="md-raised md-primary"
        >
          <md-tooltip
            v-bind:style="isMobile ? 'display: none;' : ''"
            class="tooltip"
            style="z-index: 20"
            >{{
              $t("affiliation.go-to-preference-dialog.go-to-preferences-button")
            }}</md-tooltip
          >
          {{
            $t("affiliation.go-to-preference-dialog.go-to-preferences-button")
          }}
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      role="dialog"
      :aria-modal="contestDialog"
      :md-active.sync="contestDialog"
      :md-fullscreen="false"
      class="dialog full-screen-dialog"
      :no-close-on-esc="false"
      :md-click-outside-to-close="false"
      @keydown.esc="notEsc('contestDialog')"
      @keydown.tab="
        utils.handleTabNavigation(
          $event,
          '#esterno',
          '#' + activeTab,
          '#preferencesVoteButtons',
          null
        )
      "
      :md-backdrop="false"
      id="preference-modal"
      @md-opened="
        noScroll();
        !isMobile ? utils.modalOpened('#preference-modal') : '';
      "
      @md-closed="
        !isMobile ? utils.removeModalHandler() : '';
        scroll();
        setActiveTab(null);
      "
    >
      <md-dialog-title style="margin-bottom: 0px; padding: 0">
        <div
          class="md-caption title"
          role="heading"
          aria-level="1"
          style="padding-top: 20px"
        >
          <span class="screenreader"
            >{{ $t("affiliation.preference-modal.screen-reader.title") }}:
          </span>
          {{
            $store.state.electionEvent.ElectionEvent.EventIdentifier.EventName
          }}
        </div>

        <div class="election-name" role="heading" aria-level="2">
          <span class="screenreader"
            >{{
              $t(
                "affiliation.preference-modal.screen-reader.election-name-title"
              )
            }}:
          </span>
          {{ electionName }}
        </div>
        <span role="heading" aria-level="3" class="list-title">
          <span class="screenreader">{{
            $t(
              "affiliation.preference-modal.screen-reader.preferences-selected"
            )
          }}</span>
          {{ $t("affiliation.preference-modal.screen-reader.list") }}:
          {{ affiliation.AffiliationIdentifier.RegisteredName }}</span
        >
      </md-dialog-title>
      <preference
        :preference="affiliation.AffiliationContest"
        :electionType="electionType"
        class="md-layout"
        @contestRetrieved="changeContestName"
        @preferenceSelected="preferenceSelected"
        @activeTab="setActiveTab"
        :disabled="tooMany"
        v-if="!isMobile"
        listOrCandidates="CANDIDATES"
        :previousVoted="votedPreferences"
        :electionId="electionId"
        ref="preference"
      >
      </preference>
      <preference-mobile
        :preference="affiliation.AffiliationContest"
        :electionType="electionType"
        class="md-layout"
        @preferenceSelected="preferenceSelected"
        :disabled="tooMany"
        listOrCandidates="CANDIDATES"
        v-if="isMobile"
        :previousVoted="votedPreferences"
        :electionId="electionId"
      >
      </preference-mobile>
    </md-dialog>
  </md-card>
</template>

<script>
import ProfileInfo from "./ProfileInfo";
import Preference from "./Preference";
import PreferenceMobile from "./PreferenceMobile";
import { isMobile } from "mobile-device-detect";
import Utils from "../utils/Utils.js";

export default {
  name: "Affiliation",
  mounted() {
    this.isMobile = isMobile;
    this.utils = new Utils();

    if (this.previousVoted && process.env.VUE_APP_persistPreference == "true") {
      this.previousVoted.forEach(c => {
        if (c.id == this.affiliation.AffiliationIdentifier.Id) {
          this.votedPreferences = c.preferences;
          this.vote(true); //variabile true per richiedere che non compaia la preferenceDialog
        }
      });
    }

    if (
      this.affiliation.AffiliationContest.ChoicesContest != null &&
      this.affiliation.AffiliationContest.ChoicesContest.length > 0
    ) {
      this.$emit("hasContest");
      this.hasContest = true;
    }
  },
  data: function() {
    return {
      info: false,
      voted: false,
      votedPreferences: [],
      contestDialog: false,
      tooMany: false,
      isMobile: false,
      preferenceDialog: false,
      hidediv: false,
      utils: null,
      hasContest: false,
      lastAffiliationFocus: "",
      affiliationSelectClic: false,
      activeTab: null
    };
  },
  props: [
    "affiliation",
    "disabled",
    "electionType",
    "sexVoted",
    "electionName",
    "electionId",
    "previousVoted"
  ],
  methods: {
    vote(noPreferenceDialog) {
      //noPreferenceDialog = true non mette preferenceDialog a true
      this.voted = !this.voted;
      if (!this.voted) this.votedPreferences = [];
      if (
        this.voted &&
        this.affiliation.AffiliationContest &&
        this.votedPreferences.length == 0 &&
        !noPreferenceDialog
      )
        this.preferenceDialog = true;
      // if (this.affiliation.AffiliationContest && this.voted) {
      //   this.contestDialog = true;
      // }
      this.$emit("affiliationSelected", {
        id: this.affiliation.AffiliationIdentifier.Id,
        value: this.voted,
        name: this.affiliation.AffiliationIdentifier.RegisteredName,
        preferences: this.votedPreferences,
        hasPreferences: this.hasContest
      });
    },
    selectAffiliationCardAndVote() {
      //se e' disabilitato e non votato non si può votare
      if (this.disabled && !this.voted) return;
      this.vote(false);
    },
    preferenceSelect() {
      if (this.affiliation.AffiliationContest && this.voted) {
        this.contestDialog = true;
      }
    },
    changeContestName(evt) {
      this.contestNames[evt.id] = evt.name;
      this.$forceUpdate();
    },
    preferenceSelected(evt) {
      this.votedPreferences = evt;
      this.contestDialog = false;
      this.$emit("affiliationSelected", {
        id: this.affiliation.AffiliationIdentifier.Id,
        value: this.voted,
        name: this.affiliation.AffiliationIdentifier.RegisteredName,
        preferences: evt
      });
    },
    notEsc() {
      //per ora non metto if perchè usato solo in un caso
      this.contestDialog = true;
    },
    noScroll() {
      document
        .getElementById("election-modal")
        .setAttribute("aria-hidden", "true");
      document
        .getElementById("election-modal")
        .querySelectorAll("input,button,a")
        .forEach(x => (x.tabIndex = "-1"));
      this.lastFocus = document.activeElement;
      this.hidediv = true;
      this.$forceUpdate();
    },
    scroll() {
      document
        .getElementById("election-modal")
        .setAttribute("aria-hidden", "false");
      document
        .getElementById("election-modal")
        .querySelectorAll("input,button,a")
        .forEach(x => x.removeAttribute("tabindex"));
      this.lastFocus.focus();
      if (!this.contestDialogv && this.affiliationSelectClic) {
        this.lastAffiliationFocus.focus();
        this.affiliationSelectClic = false;
      }
      this.hidediv = false;
      this.$forceUpdate();
    },
    affiliationSelect() {
      this.affiliationSelectClic = true;
      this.lastAffiliationFocus = document.activeElement;
    },
    setActiveTab(evt) {
      this.activeTab = evt;
    }
  },
  components: {
    ProfileInfo,
    Preference,
    PreferenceMobile
  }
};
</script>
<style scoped>
.md-card {
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0),
    0 0 0 0 rgba(0, 0, 0, 0);
  border: 1px solid #ccc;
  border-radius: var(--brb);
  margin-bottom: 10px;
}

.imgsize {
  max-width: 40%;
  margin: 1px;
}
.md-dialog2 {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
}
.resized {
  width: 30%;
}
.all {
  width: 40% !important;
  height: auto !important;
  max-width: 100%;
  max-height: 100%;
}
.allmobile {
  width: 30% !important;
  height: 35% !important;
  max-width: 90%;
  max-height: 100%;
  overflow: auto;
}

.title {
  text-align: left;
}
.dialog {
  overflow: auto;
}

span.md-dialog-title {
  background-color: #fff !important;
  text-align: center !important;
  margin: 0;
}

.md-dialog-content {
  padding: 20px !important;
}
.md-title {
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.005em;
  line-height: 26px;
  color: #fff;
  padding: 15px;
}

.md-subtitle {
  padding: 15px;
}
.mg {
  margin: 10px;
  padding: 5px 15px 15px 15px;
}
.dis {
  pointer-events: none;
}

.md-button {
  border-radius: var(--brb);
}

/* .md-dialog-actions .md-button {
  padding: 10px 24px;
} */
.md-button.md-theme-default.md-raised:not([disabled]).md-primary {
  color: #fff !important;
  background-color: var(--pcolor) !important;
}

.md-button.md-theme-default.md-primary .md-icon-font {
  color: var(--pcolor) !important;
}

.md-button.md-theme-default[disabled].md-primary .md-icon-font {
  color: rgba(0, 0, 0, 0.8) !important;
}

.md-dialog-actions {
  margin-bottom: 10px;
}

.election-title {
  font-size: 20px;
  letter-spacing: 0;
  line-height: 32px;
  color: #000 !important;
  text-align: left !important;
}

.caption {
  color: #fff !important;
  font-size: 14px;
}

.md-caption.title {
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  background: var(--pcolor);
  color: #fff !important;
  padding-top: 0px;
}

.dark-grey {
  color: #454545 !important;
  max-width: 70%;
  display: inline-block;
}

.primary-color {
  color: var(--pcolor) !important;
}

.preferences-color {
  color: var(--pcolor) !important;
  display: flex;
  justify-content: flex-end;
  font-weight: bold;
}

.max-votes {
  margin: 0 15px;
}

.election-name {
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  text-transform: uppercase;
  text-align: center;
  background: var(--pcolor);
  color: #fff !important;
  padding-bottom: 20px;
}

.block-lista {
  text-align: left;
}

.gutter {
  margin-left: 16px;
  margin-right: 16px;
}

.preferenze {
  text-align: right;
  position: absolute;
  bottom: 5px;
  right: 20px;
}

.preff {
  padding: 0 15px 24px;
}

.md-icon.md-size-2x {
  width: 42px !important;
  min-width: 42px !important;
  height: 42px !important;
  font-size: 42px !important;
}

.md-icon:focus-visible {
  border: 2px solid #338fff;
  border-radius: 200px !important;
}

.full-screen-dialog {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.nero {
  font-weight: bold !important;
}

.list-title {
  background: var(--pcolor);
  width: 100%;
  display: block;
  color: #fff;
  padding-bottom: 10px;
}

.pref {
  color: #333 !important;
  font-size: 14px;
  margin: 5px;
  font-weight: 500;
  vertical-align: sub;
}

.close-button {
  background-color: #fff !important;
  border: 1px solid var(--pcolor);
  color: var(--pcolor) !important;
}

.no-gutter {
  margin-left: 0 !important;
}

@media screen and (max-width: 1060px) {
  .preferences-color {
    display: block;
  }

  .max-votes {
    display: block;
    margin: 0;
  }
}

@media screen and (max-width: 768px) {
  .md-icon.md-size-2x {
    width: 35px;
    min-width: 35px;
    height: 35px;
    font-size: 35px !important;
  }

  .md-dialog-actions .md-button {
    padding: 0px 14px;
  }
}
@media screen and (max-width: 667px) {
  .all {
    max-height: 40vh !important;
  }
  .allmobile {
    height: 40vh !important;
    max-height: 40vh !important;
  }

  .election-name {
    font-size: 14px !important;
    line-height: 15px !important;
    padding-top: 5px;
    padding-bottom: 3px;
  }

  .md-title {
    line-height: 20px;
  }

  .imgsize {
    max-width: 80%;
  }
  .election-title {
    font-size: 20px;
  }
  .block-lista {
    padding-left: 5px;
  }

  .preferenze {
    text-align: right;
    position: absolute;
  }

  .list-title {
    font-size: 14px;
  }
}

@media screen and (max-width: 400px) {
  /* .all {
    max-height: 40vh !important;
  } */
  .allmobile {
    height: 52vh !important;
    max-height: 52vh !important;
  }
}
</style>
